import { Injectable, inject } from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, UrlTree,} from '@angular/router';
import {Observable} from 'rxjs';
import {BdFeatureStatusService} from './feature-status.service';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class BdFeatureStatusGuard implements CanActivate, CanActivateChild {
  private readonly _featureStateService = inject(BdFeatureStatusService);
  private readonly _router = inject(Router);


  canActivate(
    route: ActivatedRouteSnapshot,
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const featureId = route.data['featureId'];
    if (featureId) {
      return this._featureStateService.getFeatureStatus([featureId]).pipe(
        map((status) => status[featureId]),
        map((status) => {
          if (status) {
            return status;
          } else {
            return this._router.parseUrl('/sys-feature-maintenance');
          }
        }),
      );
    } else {
      return this._router.parseUrl('/sys-feature-maintenance');
    }
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const featureId = childRoute.data['featureId'];
    if (featureId) {
      return this._featureStateService.getFeatureStatus([featureId]).pipe(
        map((status) => status[featureId]),
        map((status) => {
          if (status) {
            return status;
          } else {
            return this._router.parseUrl('/sys-feature-maintenance');
          }
        }),
      );
    } else {
      return this._router.parseUrl('/sys-feature-maintenance');
    }
  }
}
